import { Contributors } from '@/types/contributors';

export const producers: Contributors[] = [
    { id: 'espn', name: 'ESPN', src: '/images/producers/espn.png' },
    { id: 'hard-knocks', name: 'Hard Knocks', src: '/images/producers/hard-knocks.png' },
    { id: 'jla-production', name: 'JLA Production', src: '/images/producers/jla-production.png' },
    { id: 'ksw', name: 'KSW', src: '/images/producers/ksw.png' },
    { id: 'lctv', name: 'LCTV', src: '/images/producers/lctv.png' },
    { id: 'library-kingdom', name: 'Library Kingdom', src: '/images/producers/library-kingdom.png' },
    { id: 'ligne-de-front', name: 'Ligne de Front', src: '/images/producers/ligne-de-front.png' },
    { id: 'mojo-media', name: 'Mojo Media', src: '/images/producers/mojo-media.png' },
    { id: 'quattro-media', name: 'Quattro Media', src: '/images/producers/quattro-media.png' },
    { id: 'son-et-lumiere', name: 'Son et Lumière', src: '/images/producers/son-et-lumiere.png' },
    { id: 'spica-productions', name: 'Spica Productions', src: '/images/producers/spica-productions.png' },
    { id: 'tony-comiti', name: 'Tony Comiti', src: '/images/producers/tony-comiti.png' },
    //{ id: 'wild-bunch', name: 'Wild Bunch', src: '/images/producers/wild-bunch.png' },
    { id: 'zoland', name: 'Zoland', src: '/images/producers/zoland.png' },
];
